// extracted by mini-css-extract-plugin
export default {"root":"oHVpp","content":"_1qC1e"};